import React, { memo, Fragment } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';

import kbaImage1 from 'media/kba-popin-image-1.jpg';
import kbaImage2 from 'media/kba-popin-image-2.jpg';
import styles from './PopinKbaInfo.module.scss';
const cx = classNames.bind(styles);

const PopinKbaInfo = ({ labels }) => (
  <Fragment>
    <h3 className={cx('title')}>Alter Fahrzeugschein (bis 30.09.2005):</h3>
    <div className={cx('description')}>
      <div>
        HSN-Nummer: unter 2 (4-stellig) TSN-Nummer: unter zu 3 (3-stellig)
      </div>
      <img src={kbaImage1} alt="" className={cx('img')} />
    </div>
    <h3 className={cx('title')}>Neuer Fahrzeugschein (ab 01.10.2005):</h3>
    <div className={cx('description')}>
      <div>
        HSN-Nummer: unter 2.1 (4-stellig) TSN-Nummer: unter zu 2.2 (3-stellig)
      </div>
      <img src={kbaImage2} alt="" className={cx('img')} />
    </div>
  </Fragment>
);

PopinKbaInfo.propTypes = {
  labels: object.isRequired,
};

export default memo(withLabels(PopinKbaInfo));



// WEBPACK FOOTER //
// ./src/components/PopinKbaInfo/PopinKbaInfo.js